import { inject, injectable } from '~/container'
import { PuLangFetch } from '~/lang/utils/pulangfetch'
import { CurrenciesRepository, CurrencyRate } from '../domain'

@injectable()
export class AjaxCurrencyRepository implements CurrenciesRepository {
  @inject(PuLangFetch)
  private puLangFetch: PuLangFetch

  async readAll(): Promise<CurrencyRate[]> {
    return this.puLangFetch.fallbackFetch('en-gb', '/_/currencies/')
  }
}
